import Blue from "~/core";

new Blue({
	name: 'news',
	selector: ".news",
	setup(news) {



		const selectDate = document.querySelector('#dateFilter');


		selectDate.onchange = (e) => {
			const [option] = e.target.selectedOptions

		
			var newsItems = document.querySelectorAll('.newsItem');
			newsItems.forEach((item) => {
				console.log(item.getAttribute('data-date'));
				if (option.value == item.getAttribute('data-date') || option.value == 'Most Recent' ) {
					item.classList.remove("hidden");
				}
				else {
					item.classList.add("hidden");
				}
			});
		};

		const selectType = document.querySelector('#typeFilter');
		selectType.onchange = (e) => {
			const [option] = e.target.selectedOptions
			//get all news items on page.
			var newsItems = document.querySelectorAll('.newsItem');
			newsItems.forEach((item) => {
				//console.log(option.dataset.newstype);
				if (option.value == item.getAttribute('data-newstype') || option.value == 'All') {
					item.classList.remove("hidden");
				}
				else {
					item.classList.add("hidden");
				}
			});


		};

	}
});